import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IconName } from '../icon/icon.component';

export type ButtonStyle = 'primary' | 'secondary' | 'outline' | 'danger' | 'custom';
type ButtonType = 'submit' | 'button';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input({ required: true }) label: string;
  @Input() buttonStyle: ButtonStyle = 'primary';
  @Input() buttonType: ButtonType = 'submit';
  @Input() disabled = false;
  @Input() stretched = false;
  @Input() inverted = false;
  @Input() dense = false;
  @Input() iconName?: IconName;
  @Input() href?: string; // If passed, the button will be rendered as link.

  @Output() click = new EventEmitter<MouseEvent>();

  onClick(event: MouseEvent) {
    event.stopPropagation();
    this.click.emit(event);
  }

  get cssClasses() {
    return {
      '-primary': this.buttonStyle === 'primary', //eslint-disable-line
      '-secondary': this.buttonStyle === 'secondary', //eslint-disable-line
      '-outline': this.buttonStyle === 'outline', //eslint-disable-line
      '-danger': this.buttonStyle === 'danger', //eslint-disable-line
      '-custom': this.buttonStyle === 'custom', //eslint-disable-line
      '-dense': this.dense, //eslint-disable-line
      '-stretched': this.stretched, //eslint-disable-line
      '-inverted': this.inverted, //eslint-disable-line
    };
  }
}
